import React from "react";
import TooltipPortal from "src/app/components/TooltipPortal/TooltipPortal";
import XssFilter from "src/app/components/XssFilter/XssFilter";

import "./TooltipField.scss";

interface Props {
  tooltipContent: string;
  fieldValue: string;
}

export const TooltipField = (props: Props) => {
  const { tooltipContent, fieldValue } = props;

  const decodedTooltipContent = XssFilter(tooltipContent, [
    "br",
    "b",
    "i",
    "u",
    "ul",
    "ol",
    "li",
  ]);

  return (
    <TooltipPortal
      content={
        <span
          className="tooltip-field-content"
          dangerouslySetInnerHTML={{ __html: decodedTooltipContent }}
        />
      }
      noHeightLimit
    >
      {fieldValue || "-"}
    </TooltipPortal>
  );
};
